import { render, staticRenderFns } from "./TestReportInfo.vue?vue&type=template&id=b6e81a30&scoped=true&"
import script from "./TestReportInfo.vue?vue&type=script&lang=js&"
export * from "./TestReportInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e81a30",
  null
  
)

export default component.exports